import { css } from "@emotion/react";

import { media } from "./breakpoints";

export const DepositModalOveride = css`
  & .modal__signup {
    &.ant-modal {
      width: 914px !important;
      height: 764px;
      ${media.xxl} {
        height: 660px;
      }
      padding-bottom: 0;
    }
  }
`;

export const MemberVipModalOverride = css`
  & .modal__member-vip {
    &.ant-modal {
      width: 1198px !important;
    }
  }
`;

export const DropDownHeaderOverride = css`
  & .ant-dropdown {
    margin-top: 10px;
    &-menu {
      li {
        background-color: white !important;
        &:hover {
          span {
            color: #ff5d08;
          }
        }
      }
    }
  }
`;

export const SelectMemberVipOverride = css`
  & .ant-select-dropdown {
    margin-top: 5px;
    padding: 10px 0;
    color: #fff;
    text-align: center;
    opacity: 0.95;
    border-radius: 3px;
    background-color: #8b5211;
    overflow-y: scroll;
    .ant-select-item {
      color: #fff;
      padding: unset !important;
      opacity: 0.95;
      min-height: 24px !important;
      &-option-content {
        font-size: 14px;
        font-weight: bold;
      }
      &-option-active {
        background-color: unset !important;
        font-weight: unset !important;
        color: unset !important;
      }
    }
  }
`;

export const DrawerMemberVipOverride = css`
  .drawer__member-vip {
    .ant-drawer {
      &-body {
        padding: 50px 0 0 0 !important;
      }
    }
  }
`;
